import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMacbookAir: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"macbook-air"} maskId="square-filled-radius-0-stroke-1-IconMacbookAir"><path d="M1 17V18.5C1 19.3284 1.67157 20 2.5 20H21.5C22.3284 20 23 19.3284 23 18.5V17H14.882L13.882 17.5H10.118L9.11803 17H1Z" fill="currentColor"/><path d="M2 4H22V16H2V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMacbookAir;
